import { render, staticRenderFns } from "./taxCustomerInfo.vue?vue&type=template&id=57812aa4&scoped=true"
import script from "./taxCustomerInfo.vue?vue&type=script&lang=js"
export * from "./taxCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./taxCustomerInfo.vue?vue&type=style&index=0&id=57812aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57812aa4",
  null
  
)

export default component.exports